import API from "./API";

export default class Artigos extends API
{
    static async all(params) {
        return this.get("api/admin/artigos/list", {params: params});
    }
    
}